export default __webpack_public_path__ + "static/media/icon_statement_prev.92f42f63.svg";